<template>
	<v-select 	v-bind:value="value"
				v-on:input="onInput"
  			  	v-on:change="onChange"
				:items="filteredDepts"
				:label="label"
				:prepend-icon="prependIcon"
				:prepend-inner-icon="prependInnerIcon"
				:readonly="readonly"
				:disabled="disabled"
				:solo="solo"
				:suffix="suffix"
				:name="name"
				:rules="rules"

				item-text="name"
				item-value="code">
	</v-select>
</template>

<script>
	export default {
		props: {
			label: String,
			value: Number,
			readonly: Boolean,
			disabled: Boolean,
			solo: Boolean,
			suffix: String,
			prependIcon: String,
			prependInnerIcon: String,
			name: String,
			rules: Array,
			allowSummary: {
				type: Boolean,
				default: false
			},
		},
		data: () => ({
			depts: [
				{
					'right': 'pl_data_view_all',
					'code': 0,
					'name': 'Полный отчет'
				},
				{
					'right': 'pl_data_view_all',
					'code': 10,
					'name': 'Главная страница'
				},
				{
					'right': 'pl_data_view_rm',
					'code': 100,
					'name': 'Номерной фонд'
				},
				{
					'right': 'pl_data_view_fb',
					'code': 200,
					'name': 'Служба питания'
				},
				{
					'right': 'pl_data_view_ws',
					'code': 430,
					'name': 'Фитнес и спа'
				},
				{
					'right': 'pl_data_view_ag',
					'code': 600,
					'name': 'Администрация'
				},
				{
					'right': 'pl_data_view_it',
					'code': 690,
					'name': 'IT системы'
				},
				{
					'right': 'pl_data_view_sm',
					'code': 700,
					'name': 'Продажи и маркетинг'
				},
				{
					'right': 'pl_data_view_en',
					'code': 800,
					'name': 'Эксплуатация здания'
				},
				{
					'right': 'pl_data_view_ut',
					'code': 850,
					'name': 'Коммунальные услуги'
				},
				{
					'right': 'pl_data_view_hl',
					'code': 870,
					'name': 'Прачечная'
				},
				{
					'right': 'pl_data_view_sd',
					'code': 880,
					'name': 'Питание персонала'
				},
				{
					'right': 'pl_data_view_hr',
					'code': 980,
					'name': 'Затраты на персонал'
				}
			]
		}),
		computed: {
			filteredDepts() {
				return this.depts.filter(dept => {
					if (dept.code == 10 && !this.allowSummary) return false
					else return this.$store.getters.userHasRight(dept.right) || this.$store.getters.userHasRight('pl_data_view_all')
				})
			}
		},
		methods: {
			onInput: function (e) {
				this.$emit('input', e)
			},
			onChange(e) {
				this.$emit('change', e)
			},
		}
	}
</script>
